import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=731fe279&"
import script from "./addProduct.vue?vue&type=script&lang=ts&"
export * from "./addProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports